/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface DepositoMovimientosModeloMLS { 
    fecha?: string;
    documento?: string;
    transaccion?: string;
    causal?: string;
    oficina?: string;
    usuario?: string;
    valor?: number;
    saldo?: number;
}